module.exports = __webpack_public_path__ + "media/images/euro_icon-d0435631e7a92329c32d9cae9efb04a0.png";